import { createSlice } from '@reduxjs/toolkit';
const SLICE_NAME = 'mainStats';

export const mainStatsSlice = createSlice({
    name: SLICE_NAME,
    initialState: {
        data: {},
        isLoading: false,
        error: null,
    },
    reducers: {
        setMainStatsData(state, action) {
            state.isLoading = false;
            state.data = action.payload;
        },
    },
});

export const { setMainStatsData } = mainStatsSlice.actions;

export const mainStats = mainStatsSlice.reducer;

export const selectMainStatsData = (state) => state.commonData.mainStats.data;
export const selectMainStatsError = (state) => state.commonData.mainStats.error;
export const selectMainStatsLoading = (state) =>
    state.commonData.mainStats.isLoading;
